'use strict';

module.exports = {
  outputDir: '../../../wwwroot/spa',
  backend: process.env.NODE_ENV === 'production' ? '' : 'https://localhost:7004',
  themeName: process.env.THEME_NAME,
  apiPrefixes: {
    v1: 'api/v1',
    v2: 'api/v2',
  },

  dev: {
    publicPath: '/',
    port: 8080,
  },

  build: {
    publicPath: '/spa/',
  },
};
